<div class="mt-2">
  <app-lt-png-table [gridSettingsInput]="pushbackGridSettings()" (deleteClicked)="setDeletingIntegrationPushBack($event)" (editClicked)="setEditingIntegrationPushBack($event)" />
</div>

<br>
<br>

<mat-accordion>
  <mat-expansion-panel #runTimePanel [expanded]="runTimePanelExpanded" (opened)="runTimePanelExpanded = true" (closed)="runTimePanelExpanded = false">
    <mat-expansion-panel-header>
      <mat-panel-title>Integration RunTimes</mat-panel-title>
      <mat-panel-description>{{ integrationRunTimes?.length ?? 0 }} RunTime(s)</mat-panel-description>
    </mat-expansion-panel-header>
    <div class="content">
      @if (runTimeGridSettings()) {
        <app-lt-png-table #runTimeGrid [gridSettingsInput]="runTimeGridSettings()" [showToolbarInput]="false" />
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>